var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_861_3894)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 11.5,
    stroke: "#E1DEDE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 7.67993C12.2346 7.67993 12.0197 7.89483 12.0197 8.15993V11.5199H8.65969C8.39459 11.5199 8.17969 11.7348 8.17969 11.9999C8.17969 12.265 8.39459 12.4799 8.65969 12.4799H12.0197V15.8399C12.0197 16.105 12.2346 16.3199 12.4997 16.3199C12.7648 16.3199 12.9797 16.105 12.9797 15.8399V12.4799H16.3397C16.6048 12.4799 16.8197 12.265 16.8197 11.9999C16.8197 11.7348 16.6048 11.5199 16.3397 11.5199H12.9797V8.15993C12.9797 7.89483 12.7648 7.67993 12.4997 7.67993Z",
    fill: "#35383D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_861_3894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.7bbed5fe63bf7965bedff4b072cab51f.svg";
export { ForwardRef as ReactComponent };